import { DatePicker } from 'antd'
import { DATE_FORMAT } from '../../../lib/MomentHelper'
import moment from 'moment'

const LOCALE = 'zh-tw'
// 換成中文語系
moment.locale(LOCALE)

// 自訂一些 wording
const locale = {
  lang: {
    placeholder: '選擇時間',
    rangePlaceholder: ['開始日期', '結束日期'],
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: '確認',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: '選擇時刻',
    dateSelect: '選擇日期',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    yearFormat: 'YYYY',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    monthFormat: 'MMMM',
    monthBeforeYear: true,
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century',
    // antd4 datepicker 如果有帶入 locale 會傳入 rc-picker 需要有設定 locale moment 才不會報錯
    // https://github.com/ant-design/antd-dayjs-webpack-plugin/issues/36#issuecomment-1281786375
    locale: LOCALE
  },
  timePickerLocale: {
    placeholder: '選擇時間'
  },
  dateFormat: DATE_FORMAT.UI,
  dateTimeFormat: `${DATE_FORMAT.UI} HH:mm`,
  weekFormat: 'YYYY-wo',
  monthFormat: 'YYYY-MM'
}

/**
 * 包裝 antd DatePicker
 *
 * 詳細可傳入 props 請參考
 * @see https://ant.design/components/date-picker/
 */
const AntdDatePicker = props => {
  return (
    <DatePicker
      locale={locale}
      format={`${DATE_FORMAT.UI} HH:mm`}
      {...props}
    />
  )
}

export default AntdDatePicker
